import { CarRouteConfig } from "@/api/adHocCommands"

export type VehicleType = "tir" | "solo" | "solo72" | "bus"

export const VEHICLE_TYPE_NAMES: Record<VehicleType, string> = {
  tir: "TIR",
  solo: "Solo 18t",
  solo72: "Solo 7.2t",
  bus: "Bus",
}

const TIR: CarRouteConfig = {
  length: "16.5",
  width: "2.55",
  height: "4",
  weight: "40000",
  maxSpeed: "85",
  travelMode: "truck",
  emissionType: "euro6",
  axleCount: "5",
  co2class: "1",
}

const SOLO: CarRouteConfig = {
  length: "11",
  width: "2.55",
  height: "4",
  weight: "18000",
  maxSpeed: "85",
  travelMode: "truck",
  emissionType: "euro6",
  axleCount: "2",
  co2class: "1",
}

const SOLO_72: CarRouteConfig = {
  length: "10",
  width: "2.5",
  height: "3.9",
  weight: "7200",
  maxSpeed: "85",
  travelMode: "truck",
  emissionType: "euro6",
  axleCount: "2",
  co2class: "1",
}

const BUS: CarRouteConfig = {
  length: "7.5",
  width: "2.4",
  height: "3.2",
  weight: "3500",
  maxSpeed: "90",
  travelMode: "car",
  emissionType: "euro6",
  axleCount: "2",
  co2class: "1",
}

export const carConfigs: Record<VehicleType, CarRouteConfig> = {
  tir: TIR,
  bus: BUS,
  solo: SOLO,
  solo72: SOLO_72,
}

const PRESET_FIELDS = [
  "length",
  "width",
  "height",
  "weight",
  "maxSpeed",
  "travelMode",
  "emissionType",
  "axleCount",
  "co2class",
] as const

const normalize = (v: unknown) => (v === "" || v === undefined ? undefined : v)

export const matchPreset = (
  config: CarRouteConfig | undefined,
): VehicleType | undefined => {
  if (!config) return undefined
  for (const [key, preset] of Object.entries(carConfigs) as [
    VehicleType,
    CarRouteConfig,
  ][]) {
    const matches = PRESET_FIELDS.every(
      (f) =>
        normalize((config as Record<string, unknown>)[f]) ===
        normalize((preset as Record<string, unknown>)[f]),
    )
    if (matches) return key
  }
  return undefined
}
